const MONTHS_IN_YEAR = 12;
/**
 * Projects the end of month balance of a savings account
 *
 * @param initialBalance The amount at t=0 of the balance
 * @param monthlyDeposit The monthly amount deposited to theh balance
 * @param interestRate The yearly interest rate
 * @returns The compunded balance for current month
 */
export function projectBalance(initialBalance, monthlyDeposit, interestRate) {
    return initialBalance * (1 + interestRate / MONTHS_IN_YEAR) + monthlyDeposit;
}
